/**
 * Given name and surname on one line, each part trimmed on its own: a name
 * pasted at the desk often carries its own leading or trailing space, and a
 * single trim at the end would leave a doubled space in the middle.
 */
export function joinName(firstName: string, lastName: string): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}

/**
 * The attendee's name as printed on the badge: surname first on Hungarian
 * events ("Fehér Norbert"), given name first for every other language and for
 * an event without one.
 */
export function badgeName(firstName: string, lastName: string, language?: string): string {
  return language === 'HU' ? joinName(lastName, firstName) : joinName(firstName, lastName);
}
